import React, { useEffect, useState } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";

const MediaBin = () => {
  const [deletedMediaList, setDeletedMediaList] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState([]);
  const [isRestoreBtnEnabled, setIsRestoreBtnEnabled] = useState(false);
  const [isDeleteBtnEnabled, setIsDeleteBtnEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectAllImageChecked, setSelectAllImageChecked] = useState(false);
  const [selectAllVideoChecked, setSelectAllVideoChecked] = useState(false);
  const [selectAllOtherFilesChecked, setSelectAllOtherFilesChecked] =
    useState(false);
  const token = config.token;

  // media restoration and permanent deletion
  const handleCheckboxChange = (mediaId) => {
    setSelectedMedia((prevSelectedMedia) => {
      if (prevSelectedMedia.includes(mediaId)) {
        // If the media ID is already in the list, remove it
        if (prevSelectedMedia.filter((id) => id !== mediaId).length <= 0) {
          setIsRestoreBtnEnabled(false);
          setIsDeleteBtnEnabled(false);
        } else {
          setIsRestoreBtnEnabled(true);
          setIsDeleteBtnEnabled(true);
        }
        return prevSelectedMedia.filter((id) => id !== mediaId);
      } else {
        // If the media ID is not in the list, add it
        if ([...prevSelectedMedia, mediaId].length <= 0) {
          setIsRestoreBtnEnabled(false);
          setIsDeleteBtnEnabled(false);
        } else {
          setIsRestoreBtnEnabled(true);
          setIsDeleteBtnEnabled(true);
        }
        return [...prevSelectedMedia, mediaId];
      }
    });
  };

  // --------------------------------------------- GET deleted media ----------------------------------------------R
  const getDeletedMedia = () => {
    setLoading(true);
    fetch(`${config.host_url}media/bin`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        if (data.status === 200) {
          // Successful response, update the deleted media list
          setDeletedMediaList(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token!");
        } else {
          // Handle Other errors
          triggerNotification(
            "error",
            "Internal server error, Please try after some time!"
          );
        }
      })
      .catch(async (error) => {
        triggerNotification("error", "Error fetching deleted media:");
        console.error("Error fetching deleted media:", error);
      })
      .finally(() => {
        // Update loading state when the request is complete
        setLoading(false);
      });
  };
  useEffect(() => {
    getDeletedMedia();
  }, [token]);

  // --------------------------------------------- Restoration of deleted media ---------------------------------------------DC
  // Function to show a confirmation dialog for media restoration
  const showRestoreConfirmation = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to restore deleted media files. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, restore them!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleRestore();
      }
    });
  };

  // If confirmed, restore media
  const handleRestore = async () => {
    try {
      const response = await fetch(`${config.host_url}media/restore`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({ ids: selectedMedia }),
      });

      if (response.status === 200) {
        // Successful Restoration
        // console.log("Media restored successfully");

        // Clear the selected media and disable the buttons
        setSelectedMedia([]);
        setIsRestoreBtnEnabled(false);
        setIsDeleteBtnEnabled(false);

        // Show a success notification using SweetAlert2
        triggerNotification("success", "Media restored successfully");

        // Fetch the updated deleted media list and set it in state
        getDeletedMedia();
      } else if (response.status === 404) {
        // Media IDs Not Found
        console.error("Media IDs not found");
        triggerNotification("error", "Media IDs not found");
      } else if (response.status === 401) {
        // Invalid Token
        console.error("Invalid token");
        triggerNotification("error", "Unauthenticated User");
      } else {
        // Internal Server Error or Other HTTP errors
        console.error("Internal server error");
        triggerNotification(
          "error",
          "Internal server error, Please try after some time!"
        );
      }
    } catch (error) {
      console.error("Error restoring media:", error);
      triggerNotification("error", "Error restoring media");
    }
  };

  // --------------------------------------------- Permanent Deletion of selected media ---------------------------------------------D
  // Function to show a confirmation dialog for permanent deletion
  const showPermanentDeleteConfirmation = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to permanently delete selected media files. This action cannot be undone. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, permanently delete them!",
    }).then((result) => {
      if (result.isConfirmed) {
        handlePermanentDelete();
      }
    });
  };

  // If confirmed, permanently delete media
  const handlePermanentDelete = async () => {
    // console.log(selectedMedia);
    try {
      await fetch(`${config.host_url}media`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({ ids: selectedMedia }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(async function (data) {
          if (data.status === 200) {
            // Successful Permanent Deletion
            // console.log("Media permanently deleted successfully");

            // Clear the selected media and disable the buttons
            setSelectedMedia([]);
            setIsRestoreBtnEnabled(false);
            setIsDeleteBtnEnabled(false);

            // Show a success notification using SweetAlert2
            triggerNotification(
              "success",
              "Media permanently deleted successfully"
            );

            // Fetch the updated deleted media list and set it in state
            getDeletedMedia();
          } else if (data.status === 404) {
            // Media IDs Not Found
            console.error("Media IDs not found");
            triggerNotification("error", "Media IDs not found");
          } else if (data.status === 401) {
            // Invalid Token
            console.error("Invalid token");
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or Other HTTP errors
            console.error("Internal server error");
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      console.error("Error permanently deleting media:", error);
      triggerNotification("error", "Error permanently deleting media");
    }
  };

  // Divide deletedMediaList into rows of 6 images each
  const rows = [];
  for (let i = 0; i < deletedMediaList.length; i += 6) {
    rows.push(deletedMediaList.slice(i, i + 6));
  }

  //------------ Select all functionality ---------
  //Images
  const handleSelectAllImageChange = (event) => {
    setSelectAllOtherFilesChecked(false);
    setSelectAllVideoChecked(false);
    const isChecked = event.target.checked;
    setSelectAllImageChecked(isChecked);

    if (isChecked) {
      const allImageIds = deletedImages.map((media) => media.media_id);
      setSelectedMedia(allImageIds);
      setIsRestoreBtnEnabled(true);
      setIsDeleteBtnEnabled(true);
    } else {
      setSelectedMedia([]);
      setIsRestoreBtnEnabled(false);
      setIsDeleteBtnEnabled(false);
    }
  };

  //Videos
  const handleSelectAllVideoChange = (event) => {
    setSelectAllOtherFilesChecked(false);
    setSelectAllImageChecked(false);
    const isChecked = event.target.checked;
    setSelectAllVideoChecked(isChecked);

    if (isChecked) {
      const allVideoIds = deletedVideos.map((media) => media.media_id);
      setSelectedMedia(allVideoIds);
      setIsRestoreBtnEnabled(true);
      setIsDeleteBtnEnabled(true);
    } else {
      setSelectedMedia([]);
      setIsRestoreBtnEnabled(false);
      setIsDeleteBtnEnabled(false);
    }
  };

  //Other Files
  const handleSelectAllOtherFilesChange = (event) => {
    setSelectAllImageChecked(false);
    setSelectAllVideoChecked(false);
    const isChecked = event.target.checked;
    setSelectAllOtherFilesChecked(isChecked);

    if (isChecked) {
      const allOtherFilesIds = deletedOtherFiles.map((media) => media.media_id);
      setSelectedMedia(allOtherFilesIds);
      setIsRestoreBtnEnabled(true);
      setIsDeleteBtnEnabled(true);
    } else {
      setSelectedMedia([]);
      setIsRestoreBtnEnabled(false);
      setIsDeleteBtnEnabled(false);
    }
  };

  // Divide deletedMediaList into separate arrays for videos and images
  const deletedVideos = deletedMediaList.filter(
    (media) => media.media_type === "video"
  );
  const deletedImages = deletedMediaList.filter(
    (media) => media.media_type === "image"
  );
  const deletedOtherFiles = deletedMediaList.filter(
    (media) => media.media_type !== "image" && media.media_type !== "video"
  );
  return (
    <>
      <Breadcrumb txt="Manage Media" subpath={["Bin"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header  align-items-center  justify-between">
            <h5 className="mb-0">Media Bin</h5>
            <div className="card-body">
              {loading ? (
                <Spinner />
              ) : deletedMediaList.length === 0 ? (
                <p className="text-center">No deleted media files found.</p>
              ) : (
                <>
                  {/* deleted videos */}
                  {deletedVideos.length > 0 && (
                    <div className="border rounded p-3 mb-3">
                      <div className="flex justify-between">
                        <h5 className="mb-3">Deleted Videos</h5>
                        <div className="border-none  mb-2   select-none">
                          <input
                            className="mr-2"
                            type="checkbox"
                            value=""
                            id="customCheckboxSelectAllVideo"
                            onChange={handleSelectAllVideoChange}
                            checked={selectAllVideoChecked}
                          />
                          <label
                            className={`${
                              selectAllVideoChecked && "text-green-600"
                            }`}
                            htmlFor="customCheckboxSelectAllVideo"
                          >
                            <span className="custom-option-body">
                              Select All Videos
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="row mb-3">
                        {deletedVideos.map((media) => (
                          <div className="col-md-2 mb-2" key={media.media_id}>
                            <div className="border-none  form-check custom-option custom-option-image custom-option-image-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={`customCheckboxDeletedVideo${media.media_id}`}
                                onChange={() => {
                                  handleCheckboxChange(media.media_id);
                                  setSelectAllVideoChecked(false);
                                }}
                                checked={selectedMedia.includes(media.media_id)}
                              />
                              <label
                                className="form-check-label custom-option-content"
                                htmlFor={`customCheckboxDeletedVideo${media.media_id}`}
                              >
                                <div className="custom-option-body h-[128px]">
                                  <video className="object-cover w-full h-full rounded">
                                    <source
                                      src={media.media_name}
                                      type="video/mp4"
                                    />
                                  </video>
                                </div>
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* deleted Images */}
                  {deletedImages.length > 0 && (
                    <div className="border rounded p-3 mb-3">
                      <div className="flex justify-between">
                        <h5 className="mb-3">Deleted Images</h5>
                        <div className="border-none  mb-2 select-none ">
                          <input
                            className="mr-2"
                            type="checkbox"
                            value=""
                            id="customCheckboxSelectAllImage"
                            onChange={handleSelectAllImageChange}
                            checked={selectAllImageChecked}
                          />
                          <label
                            className={`${
                              selectAllImageChecked && "text-green-600"
                            }`}
                            htmlFor="customCheckboxSelectAllImage"
                          >
                            <span className="custom-option-body">
                              Select All Images
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="row mb-3">
                        {deletedImages.map((media) => (
                          <div className="col-md-2 mb-2" key={media.media_id}>
                            <div className="border-none  form-check custom-option custom-option-image custom-option-image-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={`customCheckboxDeletedImage${media.media_id}`}
                                onChange={() => {
                                  handleCheckboxChange(media.media_id);
                                  setSelectAllImageChecked(false);
                                }}
                                checked={selectedMedia.includes(media.media_id)}
                              />
                              <label
                                className="form-check-label custom-option-content"
                                htmlFor={`customCheckboxDeletedImage${media.media_id}`}
                              >
                                <div className="custom-option-body h-[128px]">
                                  <img
                                    src={media.media_name}
                                    alt={`cbDeletedImage${media.media_id}`}
                                  />
                                </div>
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* deleted Other Files */}
                  {deletedOtherFiles.length > 0 && (
                    <div className="border rounded p-3">
                      <div className="flex justify-between">
                        <h5 className="mb-3">Deleted Other Files</h5>
                        <div className="border-none  mb-2 select-none ">
                          <input
                            className="mr-2"
                            type="checkbox"
                            value=""
                            id="customCheckboxSelectAllOtherFiles"
                            onChange={handleSelectAllOtherFilesChange}
                            checked={selectAllOtherFilesChecked}
                          />
                          <label
                            className={`${
                              selectAllOtherFilesChecked && "text-green-600"
                            }`}
                            htmlFor="customCheckboxSelectAllOtherFiles"
                          >
                            <span className="custom-option-body">
                              Select All Other Files
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="row mb-3">
                        {deletedOtherFiles.map((media) => (
                          <div className="col-md-3" key={media.media_id}>
                            <div className="form-check custom-option custom-option-image custom-option-image-check">
                              <label
                                className="form-check-label custom-option-content"
                                htmlFor={`customCheckboxOtherFiles${media.media_id}`}
                              >
                                <div className="flex">
                                  <div className="">
                                    <div
                                      type="text"
                                      className="p-1 border-r-2 border-gray-200"
                                      style={{
                                        height: "100%",
                                        display: "flex",
                                      }}
                                    >
                                      <span className="mdi mdi-file-document my-auto"></span>
                                    </div>
                                  </div>

                                  <div className="form-floating-outline w-full overflow-hidden whitespace-no-wrap ml-1 ">
                                    <div
                                      type="text"
                                      className=" pr-1"
                                      style={{
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <div className="">
                                        <span className="block overflow-hidden line-clamp-1">
                                          {media.media_name
                                            .split("/")
                                            .pop()
                                            .split(".")[0]
                                            .split("-")
                                            .pop()}
                                        </span>
                                      </div>

                                      <hr className="p-0 m-0" />
                                      <span className="block overflow-hidden line-clamp-1">
                                        {
                                          media.media_name.split(".")[
                                            media.media_name.split(".").length -
                                              1
                                          ]
                                        }
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </label>

                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={`customCheckboxOtherFiles${media.media_id}`}
                                onChange={() => {
                                  handleCheckboxChange(media.media_id);
                                  setSelectAllOtherFilesChecked(false);
                                }}
                                checked={selectedMedia.includes(media.media_id)}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="flex justify-end">
              {isRestoreBtnEnabled && (
                <button
                  type="button"
                  className="text-green-700 hover:text-white border border-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:border-green-500 dark:text-green-500 dark:hover:text-white dark:hover:bg-green-600 dark:focus:ring-green-900"
                  onClick={showRestoreConfirmation}
                >
                  Restore
                </button>
              )}
              {isDeleteBtnEnabled && (
                <button
                  type="button"
                  className="text-red-700 hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                  onClick={showPermanentDeleteConfirmation}
                >
                  Permanent Delete
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MediaBin;
